import React from 'react';
import './css/Button.css'; // Style for buttons
import { t } from 'ttag';
import { mixpanel } from './mp.js';

function BuyingEquityButton( {handlesetIndex, index} ) {
  return (
    <button className="primary-button" style={{fontSize : "x-large"}} onClick={() => { mixpanel.track('BuyingEquityButton'); handlesetIndex(4)}}>{t`Buy BBK`}</button>
    
  );
}

export {BuyingEquityButton};